<div #activityPopup class="overlay" (click)="closePopup()">
    <div class="popup" (click)="$event.stopPropagation()">
        <div class="header">@if (sharedService.caseNames().length) {Select Case name}</div>
        <div class="close" (click)="closePopup()">&times;</div>
        <div class="content">
            @if (sharedService.caseNames().length) {
                <div class="form-group">
                    <label for="">Select Case name</label> 
                    <app-dropdown [placeHolder]="'Select Case name'" [hasFilter]="true" [selected]="selectedCase" [list]="sharedService.caseNames()"
                        (onSelect)="saveCase($event)"></app-dropdown>
                </div>
                <div class="bt-group">
                    <button class="btn btn-primary" (click)="save()">Save</button>
                </div>
            } @else { 
                <div class="no-records">No cases were found.</div>
            }
        </div>
    </div>
</div>